/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorInfoRequest
 */
export interface ValidatorInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatorInfoRequest
     */
    address: string;
}

export function ValidatorInfoRequestFromJSON(json: any): ValidatorInfoRequest {
    return ValidatorInfoRequestFromJSONTyped(json, false);
}

export function ValidatorInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorInfoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
    };
}

export function ValidatorInfoRequestToJSON(value?: ValidatorInfoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
    };
}


